<template>
  <div class="mit-manage-buildings-page mit-page">

      <v-container fluid>
          <BaseMitLoading :show="loading" :fullscreen="false"/>
          <BaseMitTreeView class="" v-if="campus.length > 0" @click:node="selectNode" title="Explore Campus" :items="campus" :itemKey="'mitId'" :itemText="'displayName'">
            <!-- <template v-slot:title="{ titleText }">
                <v-radio-group dense row v-model="treeType" mandatory @change="treeTypeChanged">
                  <v-radio label="Grouped" value="grouped"></v-radio>
                  <v-radio label="By Host" value="host"></v-radio>
                </v-radio-group>
            </template> -->
            <template v-slot:activeNodeDetails="{ node }">
                <v-toolbar-title>{{node.displayName}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-row class="pa-4" justify="space-between">
                    <v-col cols="12" md="8">
                        <v-card flat>
                            <BaseMitChartBar :barData="chartDataObjects" title="Objects" labelX="Object" labelY="Counts" :horizontal="true"/>
                            <!-- <BaseMitChartPie style="max-height:200px;max-width:300px;" :pieData="chartDataSqFeet" legendPosition="right" title="Sq Footage" label="sqft"/> -->
                        </v-card>
                    </v-col>
                    <!-- <v-divider vertical></v-divider> -->
                    <v-col cols="12" md="4">
                        <v-card flat>
                            <!-- <canvas id="pieTop10"></canvas> -->
                            <BaseMitChartPie style="max-height:200px;max-width:300px;" :pieData="chartDataSqFeet" legendPosition="right" title="Sq Footage" label="sqft"/>
                        </v-card>
                    </v-col>
                </v-row>
                <BaseMitDataTable
                    v-if="spacesList.length > 0"
                  title=""
                  :editable="false"
                  :headers="headers"
                  :items="spacesList"
                >
                </BaseMitDataTable>
            </template>
          </BaseMitTreeView>
    </v-container>
  </div>
</template>

<script>
  import BaseMitLoading from '../../../base/components/BaseMitLoading.vue';
  import BaseMitDataTable from '../../../base/components/BaseMitDataTable.vue';
  import BaseMitTreeView from '../../components/BaseMitTreeView.vue';
  import BaseMitChartBar from '../../components/BaseMitChartBar.vue';
  import BaseMitChartPie from '../../components/BaseMitChartPie.vue';

  import MitSpacesService from '../../services/MitSpacesService.js';
  export default {
      name: 'MitManageBuildingsPage',
      components: {
          BaseMitLoading,
          BaseMitDataTable,
          BaseMitTreeView,
          BaseMitChartBar,
          BaseMitChartPie
      },
      data: function() {
          return {
              loading:true,
              campus:[],
              chartDataObjects:{},
              search: '',
              headers:[
                  {text: 'Mit Id',sortable: true,value: 'mitId'},
                  {text: 'Floor',sortable: true,value: 'level'},
                  {text: 'Sq Feet',sortable: true,value: 'sqfoot'},
                  {text: 'Org.',sortable: true,value: 'org'},
                  {text: 'Use Type',sortable: true,value: 'useType'},
                  // temporary hiding spaces
                  // {text: 'Spaces',sortable: false,value: 'accessSpacesDisplay',},
                  {text: 'Edited Date',sortable: true,value: 'dates_local.lastEditedDt',}
                ],
              spacesList:[]
          }
      },
      created() {
            //get current settings
            MitSpacesService.getBuildingSpacesTree()
            .then((data) => {
                this.loading = false;
                this.campus = [data];
            })
            .catch((error)=>{
                this.loading = false;
            });

            this.chartDataObjects = {
                labels:['Printers', 'AA Booths', 'Phonebooths', 'Card Readers', 'test1', 'test2'],
                values:[5,8,15,7,4,8]
            }

            this.chartDataSqFeet = {
                labels:['CSAIL', 'CHILD CARE', 'Other1', 'Other2', 'Other3', 'Other4'],
                values:[500,200,300,350, 400, 140]
            }
      },
      mounted(){

      },
      methods : {
          getSpacesList(options){
              this.loading = true;
              MitSpacesService.getSpaces(options)
              .then((spaces) => {
                  this.loading = false;
                  this.spacesList = spaces;
              })
              .catch((error)=>{
                  this.loading = false;
              });
          },
          selectNode(node){
              if(node){ //make sure there is a proper node here, could be null
                    this.spacesList = [];

                    if(node.spaceType === 'campus'){
                        this.getSpacesList();
                    }
                    else if(node.spaceType === 'building'){
                        this.getSpacesList({
                            buildingId:node.buildingMitId
                        });
                    }
                    else if(node.spaceType === 'floor'){
                        this.getSpacesList({
                            buildingId:node.buildingMitId,
                            level:node.level
                        });
                    }
                    else if(node.spaceType === 'space'){
                        this.getSpacesList({
                            parentId:node.id
                        });
                    }

              }
          }
      }

  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
  // .base-mit-tree-view {
  //     :deep(.scroll){
  //       max-height: calc(100vh - 380px);
  //       overflow-y: scroll;
  //     }
  // }
</style>
